import { GetSolicitantes } from '@services/api/api.ordem';
import { SelectProps } from 'antd';
import { Select } from 'antd';

export interface SelectSolicitanteProps extends SelectProps {}

function SolicitanteSelect({ ...restProps }: SelectSolicitanteProps) {
  const { isLoading, data, isFetching } = GetSolicitantes();
  return (
    <Select
      {...restProps}
      loading={isLoading || isFetching}
      optionFilterProp="children"
      allowClear
      showSearch
      disabled={isLoading}
    >
      {data.map((c) => (
        <Select.Option key={c.id} value={c.id}>
          {c.nome}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SolicitanteSelect;
